import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Panel, Tabs, Tab } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import moment from "moment";
import { api } from "../../_services";
import ActionCountMap from "./actionCountMap";


import "./index.css";

class DashboardActionCountMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataItemsLastDay: [],
      dataItemsLastWeek: [],
      tabState: 1,
      listLoading: true,
      listLoading2: true,
    };
  }

  componentDidMount = () => {
    if (this.props.currentPrecinct) {
      if (this.props.currentPrecinct.id !== 0) {
        this.getAlertDevices({ "precinct": this.props.currentPrecinct.id }, { "precincts": this.props.currentPrecinct.id });
      } else {
        this.getAlertDevices({});
      }
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.currentPrecinct !== nextProps.currentPrecinct && nextProps.currentPrecinct) {
      if (nextProps.currentPrecinct.id !== 0) {
        this.getAlertDevices({ "precinct": nextProps.currentPrecinct.id }, { "precincts": nextProps.currentPrecinct.id });
      } else {
        this.getAlertDevices({});
      }
    } else if (this.props.reloadCount !== nextProps.reloadCount) {
      if (nextProps.currentPrecinct.id !== 0) {
        this.getAlertDevices({ "precinct": nextProps.currentPrecinct.id }, { "precincts": nextProps.currentPrecinct.id });
      } else {
        this.getAlertDevices({});
      }
    }
  }

  handleSelect = (e) => {
    setTimeout(function () {
      this.setState({
        tabState: e,
      });
    }.bind(this), 400);
  }

  /* Retrieve action count */
  getAlertDevices = (param1, param2) => {
    this.setState(() => {
      return {
        listLoading2: true
      };
    });
    const url = "/api/v1/devices/";
    const alertUrl = "/api/v1/stats/alerts/";
    const token = this.props.user.token;
    const params = {};
    const params2 = {};
    if (param1) {
      for (const key in param1) {
        params[key] = param1[key];
      }
    }
    if (param2) {
      for (const key in param2) {
        params2[key] = param2[key];
      }
    }
    const errorMsg = "Unable to retrieve devices.";
    api.getFetch(url, params2, token, errorMsg).then(json => {
      return json;
    }).then((data) => {
      params.period_start = moment().subtract(1, "d").format();
      api.getFetch(alertUrl, params, token, errorMsg).then(json => {
        const combineData = data.results.map((device) => {
          const alertCount = json.within_period.alert_counts_by_device_id[device.id];
          const cloneDevice = _.clone(device, true);
          cloneDevice.alertCount = alertCount ? alertCount : 0;
          return cloneDevice;
        });
        this.setState(() => {
          return {
            dataItemsLastDay: combineData,
          };
        });
      }).then(() => {
        params.period_start = moment().subtract(7, "d").format();
        api.getFetch(alertUrl, params, token, errorMsg).then(json => {
          const combineData = data.results.map((device) => {
            const alertCount = json.within_period.alert_counts_by_device_id[device.id];
            const cloneDevice = _.clone(device, true);
            cloneDevice.alertCount = alertCount ? alertCount : 0;
            return cloneDevice;
          });
          this.setState(() => {
            return {
              dataItemsLastWeek: combineData,
              listLoading: false,
              listLoading2: false,
            };
          });
        });
      });
    });
  };

  render() {
    const { configList, toggleFunction } = this.props;
    const { tabState, dataItemsLastDay, dataItemsLastWeek, listLoading, listLoading2 } = this.state;

    if (!configList) {
      return null;
    }

    if (listLoading) {
      return (
        <Panel className="panel-length actionCountMap">
          <div className="loading2" />
        </Panel>
      );
    }

    return (
      <Panel className="panel-length actionCountMap">
        <div className="panel-title">
          Reportable Alerts and proximity {listLoading2 && <FontAwesome className="loadingIcon" name="spinner" spin />}
          <a className="pull-right btn btn-primary" onClick={() => toggleFunction()}><FontAwesome name="chart-bar" /></a>
        </div>
        <div className="panel-body">
          <Tabs defaultActiveKey={tabState} id="actionMapTabs" className="actionMapTabs" onSelect={(e) => this.handleSelect(e)}>
            <Tab eventKey={1} title="Last 24 hours">
              {tabState === 1 &&
                <ActionCountMap dataItems={dataItemsLastDay} period_start={moment().subtract(1, "d").format()} />
              }
            </Tab>
            <Tab eventKey={2} title="Last week">
              {tabState === 2 &&
                <ActionCountMap dataItems={dataItemsLastWeek} period_start={moment().subtract(7, "d").format()} />
              }
            </Tab>
          </Tabs>
        </div>
      </Panel>
    );
  }
}

function mapStateToProps(state) {
  const { configList } = state.configuration;
  const { user } = state.authentication;
  return {
    configList,
    user
  };
}

export default connect(mapStateToProps)(DashboardActionCountMap);



// WEBPACK FOOTER //
// ./src/_components/DashboardActionCountMap/index.js